import React from 'react';

export default function NariComments() {
    return (
        <div className="nari-comments">
            <div className="u-container u-pt-5">
                <header className="d-inline-block">
                    <div className="float-left">
                        <img alt="logo" src="/images/nari-pfp.jpg"/>
                    </div>
                    <div className="float-left">
                        <div>Nari's Comment Corner</div>
                        <div>Professional Unhinged Commenter</div>
                        <div className="u-pt-h">
                            <ul className="navigation__list">
                                <li className="navigation__item navigation__dropdown">
                                    <a className="navigation__link-nari" href="https://archiveofourown.org/users/nikandrros/pseuds/nikandrros">AO3</a>
                                </li>
                                <li className="navigation__item navigation__dropdown">
                                    <a className="navigation__link-nari" href="https://www.tumblr.com/nikandrros">Tumblr</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </header>
            </div>
            <div className="u-container u-pt-5">
                <section className="block u-p-3 light_theme-nari ">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Lavender Clouds </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 1</h4>
                        </div>
                    </div>
                    <p>Okay, so, hear me out... This is going to be a fucking weird comment but I swear I can make you
                        laugh at
                        least once (and a half).</p>

                    <p>This isn't the first fanfic of yours that I read in the past few weeks (month?), I actually
                        started with
                        Lavender Sand and then I was like "yeah, what the fuck, this person writes the good shit" and
                        just then
                        I came here to read this one. I read this entire work, all 144 chapters, in three days. And then
                        I went
                        back to your profile to see your other stuff and I almost hit my head against the wall because
                        this one
                        was the only finished work, and then I decided to see if you had anything else finished in your
                        ffnet
                        AND COLOUR ME SURPRISED when I found Lavender Sand finished... and then I read the entire stuff
                        in three
                        days too. And I read your other works, not necessarily before or after going back to LS. But
                        anyway, the
                        point is that I made myself a promise to come back to all of your works I've read when I had
                        some time
                        to spare and leave you a comment (pff, several, actually). I will start my crusade by commenting
                        on your
                        first work I've finished and I will do so in here because I did it here, so you can wait for me
                        on ffnet
                        since I've read the other stuff in there. This is just me giving you a heads up because, girlie,
                        you
                        will be seeing me. I will try to commment every 10 chapters, since you weren't shitting me with
                        a name
                        with "long stories" in it.</p>

                    <p>Can you believe I found your works by chance when I saw someone saying something about crackships
                        on
                        tumblr? I don't remember what it was, but I found the links to your stuff. I'm so happy I
                        clicked on a
                        link and wasn't scammed.</p>

                    <p>See you in 10, xoxo &lt;3</p>
                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Lavender Clouds </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 10</h4>
                        </div>
                    </div>
                    <p>When I started reading this fanfic I didn't really like it but I kept going because I knew
                        Lavender Sand
                        was really fucking good and this one had the potencial to be as well! I'm kidding, I kept
                        reading
                        because I thought the concept was funny and I enjoy watching a circus burning down, and this one
                        here
                        sounded chaotic, but the more I read the more curious about the outcome I got.</p>

                    <p>Starting from the beginning: I loved it when Hinata just decided to kick the bucket and fuck off.
                        Fucking
                        off is scary but it can be so good for the soul, right? (RIGHT?). I remember Hinata saying
                        herself she
                        overreacted at the beginning but I don't really agree to that, I don't think it was an
                        overreaction to
                        want some time alone to get your shit together and lose your temper when the people (somehow)
                        responsible for your turmoil won't leave you alone, and also the stuff about not having your
                        pain
                        validated. Girlie wanted to feel her feelings, even when they weren't good, and not being left
                        alone to
                        do so can be tiring. There is only so much a tired person can take.</p>

                    <p>There was a scene in Naruto Shippuden where Sakura wants Naruto to not leave her or something,
                        and then
                        she kind of says she will reciprocate his feelings? Or something on this line, but he refuses
                        because he
                        knows she will never love him the same way and she just wanted a crutch for the pain/loneliness.
                        I never
                        really liked her but I never had anything against her as a characters, but this scene made me
                        seethe,
                        because she wasn't only being stupid to Naruto, who loved her, but it was right after the Pein
                        attack,
                        right after Hinata confessed to Naruto. Your dialogue about Naruto not knowing about Hinata's
                        feelings
                        and Hinata telling him Sakura knew reminded me of this moment from the show, because knowing
                        about
                        Hinata's feelings wouldn't stop Sakura at all.</p>

                    <p>Tell you what, when Tsunade said Hinata might enter the bingo book one day, I'm sure she wasn't
                        expecting
                        Hinata to take that as a challange and get herself a whole page of crimes. Hinata was literally
                        living
                        her cotagecore dream, meanwhile Tsunade in her office like "THE FUCK IS SHE DOING WITH
                        ITACHI?"</p>

                    <p>But my girl ended up in Suna, I ended up shipping gaahina, and Gaara ended up crying and
                        listening to
                        Call Out My Name by The Weeknd for a year. And on that note, I wasn't expecting the gaahina in
                        here to
                        be so soft and sweet because I knew what was coming on the way, and it broke my heart all the
                        same when
                        it ended. Give Gaara more hugs and head pats, the challenge.</p>

                    <p>"If she had let herself, she could have easily fallen in love with the mysterious man filled with
                        old
                        scars." She really has a type, huh?</p>

                    <p>I shit you not, I heard the wedding bells inside my head when Itachi first showed up (might also
                        have
                        been my mental illness, who knows?). I love this motherfucker in canon, I loved him in here, I
                        love him
                        in your other stories, I can't go a day without loving him all around the place like a rhino on
                        a
                        rampage. This story made me ship itahina as well, and their friendship in here got me CRYING MY
                        EYES OUT
                        because HOW DARE HE? I would beat the illness out of him if I could. Hinata is literally the
                        only
                        character I can see babying fucking criminals, it was so fucking funny when she was treating
                        Itachi and
                        Kisame (and Deidara, and Hidan) and they didn't want the whole treatment and she was like "I
                        will take
                        care of you whether you want it or not" and pointing the metaphorical knife at them.</p>

                    <p>"Itachi’s lip quirked up. He thought this was funny. Hinata’s face turned red." Kiss him on the
                        mouth
                        then :D</p>

                    <p>Overall, cutting your hair can be really freeing... As well as joining a terrorist organization
                        because
                        some handsome stranger smiled at ya, we've all been there, girl.</p>

                    <p>xoxo</p>
                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Lavender Clouds </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 17</h4>
                        </div>
                    </div>
                    <p>Kisame in chapter 11 did such a number on me I couldn't possibly predict he would become the
                        family's
                        official favorite uncle, and yet (and yet I got another ship, even though I already have so
                        many.
                        Hinata's harem keeps getting bigger). I am rereading as I'm writing the comments, and I
                        absolutelly love
                        how Hinata can be such a mom to these grown ass terrorists. "She didn’t expect the man to be
                        such a
                        baby. Kisame moaned, whined, and complained throughout the whole process." I LOVE YOU, SHARK
                        DUDE.</p>

                    <p>You might be the fucking best writing the intricate and delicate faces of human relationships and
                        trauma,
                        but do you know what? I rolled myself off the bed the first time I was reading this story
                        because Kisame
                        and Itachi were like Chip 'n Dale putting up shit like “Why does she get to say when we leave?”
                        and
                        “Because she sewed your guts back in.” This is gold in its purest form.</p>

                    <p>Also: Itachi respecting her, Hinata feeling proud of herself because of him, Kisame letting her
                        do her
                        thing. The three of them were my favorites from the start, right up until the end. Even after
                        Itachi
                        died I thought regularly about how much I was missing (him) their dinamic, the three of them
                        started the
                        family and it was such a devastating pain when Itachi wasn't there anymore. The three of them
                        were just
                        so comfortable to have around, and it felt like such a huge thing when they weren't there all
                        the time
                        anymore. I think you are really talented writing comfort stuff, because when you make your
                        characters
                        care for each other you make us readers care for them in return, and the hardest thing in
                        writing a good
                        story (to me, at least) is to make characters human enough and to give - or reproduce - their
                        personalities well enough, and you can do that so nicely, even when they get a little out of
                        character
                        you can still pull that off because you give them humanity and reason to do so. You have a very
                        human
                        and detailed way of saying things, which makes your writing emotional without sounding fake
                        (also helps
                        that I think you're great with your plots).</p>

                    <p>“You’re a regular housewife.” SO? SHE'S KEEPING YOU ALIVE, DIPSHIT. I mean, she is a hot
                        housewife, I
                        want her to be my housewife too. It's really cute how Kisame went from "I don't trust you, I
                        will end
                        you" to "You're usefull" to "I would die for you" so quickly, the three stages of adopthing a
                        missing-nin.</p>

                    <p>Hidan mocking Hinata when he first showed up is just so funny to me, not only because he will
                        have his
                        ass handed to him, but because he also becomes an uncle. Fuck you, Hidan.</p>

                    <p>Pein was my first favorite character in Naruto Shippuden. He was literaly why I decided to give
                        this part
                        of the story a go, and it was so fucked up to me what he became because he used to be the
                        sweetest
                        motherfucker in town when he was still Yahiko, he had so MUCH humanity in him. Reading him in
                        here made
                        me remember how much I loved Yahiko, Nagato and Konan, because you brought up that Pein was
                        human. I've
                        read a shit ton of fanfic, and they almost never talk about this, about him being a person who
                        gets food
                        poisoning and thinks stuff are funny. I was so sad after the war part bc he never showed up
                        again, even
                        though Hinata would accept him with them. I'm nostalgic because reading him in here for the
                        second time
                        makes me remember soft things.</p>

                    <p>Do you know that feeling when amazing fictional locations are destroyed? That feeling of
                        hopelessness,
                        even though the places do not exist, but the memories in there are just as strong as if they're
                        real? I
                        feel that a lot, because I think the memories are what build a home. Hinata's little cottage was
                        a home,
                        as well as a bribe, and everyone had a good time in there. It's so bittersweet. I think her
                        house was a
                        character just as any other, because it had a personality and served a purpose just like any
                        other.
                        Seeing it again and knowing they will need to move on eventually hits really hard. Anyway,
                        Akatsuki
                        could totally be a real state agency, it seems.</p>

                    <p>I love it when Hinata is missing having people around and thinks "hey maybe I shouldn't be
                        emotionally
                        dependent on criminals" and then she gets emotionally dependent on them anyway.</p>

                    <p>Oh yeah, I meant to ask you something when I first read. The books Pein gave her for her research
                        were
                        previously owned by Tobi? He talks about his later on, about the research being compromised. I
                        thought
                        the icky feeling she had was because the books were owned by Orochimaru, since he is a fucked up
                        psychopath who was part of Akatsuki before.</p>

                    <p>Thank you for introducing the art of killing people by Hinata's pretty hands too, it gave me life
                        and joy
                        and hapiness and I twirled my hair and giggled a lot :D I was so caught up in the euphoria of
                        murder
                        that for like a minute I lived in a world where Itachi didn't have an autoimmune disease.</p>

                    <p>SASORI AND DEIDARA ARE HERE, FINALLY. LAV, I LOVE THEM SO MUCH, YOU HAVE NO IDEA. I COULD WRITE
                        YOU A
                        FUCKING ESSAY ABOUT THEM AND NEVER SHUT UP ANYMORE. I'm not gonna talk too much about them right
                        now
                        because I have stuff to talk about them later, but I will let you know I already started reading
                        with a
                        heavy heart because I knew some of them wouldn't make it. I got attached anyway, I never claimed
                        to be a
                        smart girl.</p>

                    <p>I think Sasori was just so fucking confused. I also think it's funny how what made it for him,
                        regarding
                        Hinata, was pretty much what did it for Gaara in LS: being treated gently not because she was
                        wary of
                        them, but because she saw them as deserving of it as any other person. She saw both of them as
                        people
                        and treated them as such, and it really did a number on them. Funny, considering how Gaara and
                        Sasori
                        behave about each other in here.</p>

                    <p>You said it was rough to not make Sasohina and, well... yeah. It was hard on me too because how
                        dare you
                        make Sasori such a complex and interest character, the travesty. The travesty in giving him
                        something he
                        could only long for and never truly have because he isn't like the other men around. He kind of
                        had her,
                        and he decided to stay even though it hurt emotionally, because in the end having something
                        bittersweet
                        was better than having nothing at all after all the love and care. It reallu hurt because you
                        made them
                        care for each other so much, in Hinata learning about him and how to help him (as she did to
                        everyone)
                        and him taking care of her in his own way. I never expected Sasori in here. I never expected him
                        to be a
                        possibility, AND YET, YOU KNOW? You woke up one day and told yourself "today I'm going to hit
                        Nikandrros
                        in the face with a fucking brick" when you decided to post in here and rolled with it until I
                        found you.
                        I could kiss on the forehead, tho.</p>

                    <p>"Deidara acted like a civilian teenager, flirting, rebelling, and throwing tantrums, especially
                        when she
                        told him how long she would keep him. No one in the Akatsuki had any patience at all. He was
                        also rather
                        sweet, passionate, and funny." And it fucks me from behind. This Barbie son of a whore was so
                        suicidal
                        and loathed himself so much it became narcissism. It seems like with Deidara, in canon, he never
                        felt
                        like he was enough to a point where he just wanted to be remembered when he died. You gave him a
                        reason
                        to stay, you got him coming back too. Being alive might not have worked in the long run, but at
                        least to
                        me, it felt like you respected him and did him some justice. I'm thankful to you for being good
                        to him.
                        I cried a lot about him.</p>

                    <p>To be honest I cried very often. I cried every 3 chapters, I think. My best friend made a count
                        of how
                        many times I texted her in the three days of reading saying "I'm crying about this shit again I
                        will
                        throw myself from the window" and it was a lot of times. No windows were harmed throughout my
                        stay,
                        don't worry.</p>

                    <p>“You’re looking at me but not at me. Just who is that I remind you so much of?”<br/>
                        No need to lie. “A friend.” No reason to tell the whole truth, either.<br/>
                        “Lover?” Now Sasori was trying to push her buttons.<br/>
                        “No, actually. Just a friend.”</p>

                    <p>This is about all of the "what could have been". I'm totally unhealty about how much out of time
                        Hinata
                        was in here. Out of time with her loved ones, never reaching when she could, never having enough
                        time
                        with them. She lost Naruto before even having him, she lost the possibility of Gaara, she lost
                        Itachi
                        when he was within reach, she lost Sasori to things that weren't their fault and happened before
                        her
                        time. It kills me, it fucking obliterates me, that her time was made of missing chunks of things
                        that
                        never came to be, of flowers that never grew, of impossible possibilities. I thought she didn't
                        have as
                        much chemistry with Sasuke as she had with her other possibilities, but what made it truly work
                        for them
                        imo was that Sasuke was just there at the right time. He stayed. Even when they thought they'd
                        lost each
                        other they didn't because they were in the right time, for once, and they didn't want to let it
                        go.</p>

                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Lavender Clouds </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 20</h4>
                        </div>
                    </div>
                    <p>I had to cut my previous comment short because AO3 is being mean to me and it won't let me leave
                        you my
                        scrolls of mental illness. But anyway, pretent it is still the previous comment.</p>

                    <p>I went back to ffnet yesterday after leaving the second comment because I wanted to give Lavender
                        Umbrella a chance and it made me realize stuff and I'm totally going insane. You created your
                        own little
                        world inside your stories, you have the characters humanity and you gave them things to enjoy
                        and care
                        about, and you worked those things in your other works. Gaara and his thing about hugging Hinata
                        and
                        hiding in her tummy in Lavender Sand, Kisame enjoying the cooking and being taken care of in
                        Lavender
                        Umbrella, Itachi in Testing Success being a stable source of comfort and tranquility even in his
                        worst
                        moments, Sasuke being weirdly good with kids and having a good head on his shoulders when it
                        comes to
                        help Hinata because he cares about her and doesn't expect shit in return in What He Left Behind.
                        It is
                        too soon to analise Death Wishesand I haven't read Wheels and Lavender Memories yet, but you are
                        solid
                        with your description of their core traits and it is so nice.</p>

                    <p>Btw, stop killing Itachi. You're literally the god of your own world, give the poor soul a rest
                        and a
                        vacation in Hawaii. I'm kidding, you do what you must, but I get so sad because he is there and
                        he is
                        nice and then boom: doom. It just fucks me over because Hinata really tried, and she wanted to
                        keep
                        trying finding a way to help him, and they had nice vibes, I am so weak for nice vibes, you
                        know?</p>

                    <p>"Hinata must have looked like a miserable mess. She couldn’t help it. She wiped away a frustrated
                        tear.
                        Itachi pulled her up by her hands. She felt useless. She had done so little and had already hit
                        a wall.
                        Itachi led her to the kitchen and made her tea. She was mourning him, and he wasn’t even dead
                        yet." I
                        think he was already dead in the moment he resigned to it, to be honest. And I think Hinata knew
                        that
                        too. There were several moments I think he wanted to kiss her, and that was not one of those,
                        but I
                        think it was the moment it hit Itachi how much he trusted her. He was also with a foot in the
                        grave and
                        still went for the base with Hidan for her, I will KILL ALL OF THE WINDOWS IN THE WORLD-</p>

                    <p>Kisame's hugs. Kisame's hugs and Kisame being lovely. And Kisame's tenderness. Kisame in general,
                        just
                        Kisame. And cuddles. I'm having a stroke, do you feel me? I developed such and attachment to a
                        dude I
                        thought it was just a little funny and now I want to lick his face.</p>

                    <p>See you in 10 &lt;3 xoxo</p>

                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Death Wishes </h2>

                        </div>
                        <div className="col text-right">
                            <h4>Chapter 6</h4>
                        </div>
                    </div>
                    <p>I'm taking a break from commenting in Clouds, so here I am. And I also had shower thoughts about
                        Death
                        Wishes and decided to share them because you're stuck with me now.</p>

                    <p>I know you are really good with comfort, romance, drama, fluff, slice of life, action, and so and
                        so...
                        But I don't why it never crossed my mind that you could be good with thriller as well. I love
                        horror
                        stuff, I love supernatural things and dark themes around it, and I was so surprised to read this
                        one
                        here because it reminded me a little of The Haunting of Hill House (both the book and the show),
                        because
                        we readers know Itachi is some supernatural being, but Hinata didn't, and her questioning about
                        her
                        mental health still sounded solid, but the line between madness and otherworldly was still
                        present. The
                        other reason why it reminded me of Hill House is because of how you intertwined familial drama -
                        which
                        by itself is another kind of psychological horror - and world-building. F*** me, you're such a
                        great
                        author.</p>

                    <p>Loneliness is a kind of horror too, and you built it up well enough to imply mania and intrusive
                        thoughts, so many thoughts Hinata thought she made someone up to cope. I love when mental
                        illness is
                        used as a source of fear. She even projected her loneliness in Itachi, it broke me.</p>

                    <p>I was curious about Hinata and her "deserving to suffer" but I don't think this is worth
                        mentioning
                        because the story will explain ...</p>

                    <p>This message has been truncated due to length. To view in full, please visit site.</p>
                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Lavender Clouds </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 26</h4>
                        </div>
                    </div>

                    <p>Guess who's back? :D Not Itachi. I am not as good as him but I can be your personal clown, how
                        about
                        that?</p>

                    <p>If I was in Hinata's position I would just leave Hidan be. Leave him screaming and crying and
                        throwing up
                        until death takes pity on him. Leave him outside in the cold for all that I care. Good thing I'm
                        not in
                        her position. I vibe so much with Kisame when he “I would have at least tortured him a little.
                        Maybe put
                        his legs where his arms go.” I feel you, bro.</p>

                    <p>"She made sure Itachi had more than enough medication for his mission. Kisame teased her for her
                        tone
                        when she warned him about what she prescribed. Hinata only spent a couple of days alone with her
                        research, and Sasori and Deidara returned. She was confused as they weren’t hurt. Apparently,
                        they
                        usually hid between missions at hideouts everywhere, and Deidara wanted to stay with her. Sasori
                        told
                        her this, much to Deidara’s embarrassment." No, because this paragraph is just priceless. Let me
                        dissect
                        it: it's about the lengths she went for their well-being. I'm pretty sure the last time Itachi
                        felt
                        taken care of was when he was a literal child. Not sure if Kisame and Deidara ever had someone
                        caring
                        about them so much, mainly Deidara when he got hurt and had Hinata mothering the fuck outta him.
                        Sasori
                        might have it at some point, but he is like, 30? Something around it. And he is a puppet. And
                        Hinata
                        still took the time to learn about him and she's genuinely interested in learning everything
                        about him,
                        to help him in case he needs it. Can you imagine how much it meant to him to have someone
                        caring? She's
                        not only their medic, but she gets attached and they know it, they can feel it, they can fucking
                        see it.
                        I'm crying again and I am not even kidding this time, because it's so fucking nice to read
                        characters I
                        care about being taken care of by my favorite girl.</p>

                    <p>Reading about her time with them is so funny because, at times, it just feels like a really tired
                        kindergarten teacher dealing with super powerful toddlers. God help Hinata. This is really
                        Gakuen
                        Babysitters but there's only one babysitter, the children are murderers, and the daycare is on
                        fire.</p>

                    <p>I would exchange an arm to read more about Sasori all nervous around Hinata. I want to swallow
                        their
                        interactions so it will live forever inside of me, and I want to read fanfic about them
                        desperately, but
                        there's none out there (I checked). So please, take some mercy on me and write a heated making
                        out
                        session.</p>

                    <p>The domesticity of everything is what hits harder for me. The normalcy of having a home to come
                        back to,
                        the will to come back home alive, having someone who simply wants you as you are and wouldn't
                        change you
                        (because of something as irrelevant as murder). I know it is cliché, but having
                        something/someone you
                        care about is what makes you a truly wonderful fighter. In their case, later, they really want
                        to come
                        back to Hinata and they make it out alive. I think this is the weirdest thing for people who
                        never had
                        it easy. Think Kisame in later chapters, so tender and caring, compared to his first encounter
                        with
                        Hinata. It's about the growth. They even come to respect the weapon's at the door rule and it's
                        magnificent.</p>

                    <p>It does prove my point when Kisame asks Hinata to stay when she's away.</p>

                    <p>I also love how they get to know Hinata. How every little thing is mutual, like when Itachi
                        noticed the
                        clothes around the house weren't hers. This is such a small detail, but it shows that they cared
                        to
                        learn about her as much as she did them.</p>

                    <p>I totaly forgot about her mission with Sasori and Deidara. When I read it for the first time I
                        was so
                        emotionaly hurt. It must have been such a shitty situation for everyone involved. And Gaara. Oh
                        my dear,
                        Gaara.</p>

                    <p>If my man Gaara was already fucked up in the head blasting the top 3 saddest The Weeknd songs in
                        his
                        office, I'm sure he started listening to Passenger. Let Her Go was top #1 song in Suna against
                        everyone's will. Blame it on Hinata.</p>

                    <p>No, really, I want a whole soap opera on Gaara's point of view. The person he loves fucked off to
                        be a
                        terrorist and was siding with a guy he not only despises but looks a lot like him. HMMM. Jokes
                        aside, I
                        think it broke him when she said “he left me here”.</p>

                    <p>“Will you let me leave?”<br/>
                        “If you never come back.”</p>

                    <p>Can you hear it? Can you hear me SCREAMING, CRYING, THROWING UP, PASSING OUT, SHITTING MYSELF?
                        No?
                        Okay.</p>

                    <p>And Hinata was so worried about being a failure and facing Sasori... but he was so tender. I
                        swear I
                        screamed when Kisame hugged her, I can't even imagine how they felt when they found out what
                        happened in
                        Suna. It fucks me that she was so prepared to be scolded and rejected but got some grown ass men
                        worried
                        a ton about her. I think when Itachi explained that "it might happen" about their deaths it
                        really upsat
                        her because she just realized how much she cares about them.</p>

                    <p>Now... Sasohina. Sasori already knew about Gaara, and Gaara found out about Sasori. And I think
                        if Sasori
                        wasn't in love already by chapter 26, he certainly is past it because his “it used to be the
                        other way
                        around” is delivered with suck a shock, you know? He didn't expect to be someone important
                        enough for
                        her to go all this way looking for him...</p>

                    <p>See you later, I'm done today. God fucking help me here.</p>
                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Lavender Clouds </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 27</h4>
                        </div>
                    </div>
                    <p>We need to talk about chapter 27, girl, because... because! That's when the other shoe drops for
                        Hinata,
                        I think. She decides to learn how to be lethal AND GIRL!!!!! "She could have got people she
                        cared about
                        killed with her carelessness. Incapacitating people couldn’t be her main option anymore." and
                        "Sasori
                        hand-delivered her to Suna, risking his own safety. Hinata should be able to do the same."
                        Hello? Excuse
                        me? It punches really hard how she thought about what he had done for her because there she is
                        thinking
                        of him and Sasori still can't believe she gives a damn about him. IF HE ONLY KNEW.</p>

                    <p>You know I loved murder kitten Hinata. You are very much aware of how much I loved her technique,
                        and I
                        really wished she had exploded more guts out and about, she would look beautiful doing so. I
                        wanted her
                        family to see what she became, what she was without the leash.</p>

                    <p>I will love Hinata forever for threatening Itachi with... health care? Whatever the fuck they
                        have going
                        on is beautiful... for now. She even mothered Kisame, it was a truly beautiful chapter.</p>

                    <p>“I wasn’t planning on getting ambushed.” Kisame defended.<br/>
                        “That is my point!"</p>

                    <p>I'm actually laughing like a psychopath. The fucking foreshadowing.</p>

                    <p>[me at the beggining of chapter 28 like] OH MY FUCKING GOD IT'S HAPPENING, EVERYONE IT'S FUCKING
                        HAPPENING AND I'M NOT NORMAL ABOUT THIS FIGHT AND I WILL NEVER BE AND I HAVE A LOT OF THINGS TO
                        SAY THAT
                        I WILL LIST DOWN BELLOW</p>

                    <p>Hinata's desperation to find Sasori<br/>
                        Sakura seeing the consequences of her decisions and what was made of Hinata AND acting surprised
                        about
                        it<br/>
                        Hinata putting up a fight AND MAIMING A SENIOR CITIZEN<br/>
                        “I WILL go through you to get to him.”<br/>
                        Sakura telling Hinata she can't treat Sasori and Hinata like YOU FUCKING WATCH ME<br/>
                        “Do you know who he is?” “Do you?” “This isn’t like you.” “How would you know? I don’t remember
                        us being
                        close.”<br/>
                        When the old lady asked what Gaara would think of her and Hinata almost foaming at the
                        mouth.<br/>
                        “Her lungs are collapsing. You should help her.”<br/>
                        HINATA TOSSING SASORI OVER HER SHOULDER LIKE A SACK OF POTATOES</p>

                    <p>I actually want to riot and defenestrate stuff because you could have done sasohina A Thing. It's
                        so
                        ridiculously well done I want to bite something. Hinata worked her fucking ass off to keep
                        Sasori alive
                        because she cared about him, she needed him, she owed him. He learned how to maim and kill
                        because of
                        him. He must have meant SO MUCH to her and... did he even know? I mean, he was surprised she
                        even tried,
                        he didn't want her to hurt herself saving him, THIS IS PEAK DRAMA.</p>

                    <p>"Hinata was reminded how little of him was left human, even after working on him for hours. He
                        didn’t
                        feel the pain of the chips and chunks out of his body. Could he feel her bloody fingers, or was
                        he numb
                        to that too? Did he still feel the warmth of her hands, or was he cold to the world?" This. This
                        thing
                        right here made me have an epiphany in the bathroom.</p>

                    <p>What does it mean to be human? Is it something we feel inside our bodies, is the the chemicals
                        inside our
                        brains? Is it a concept, a code we create and follow through our whole lives? Because as far
                        from human
                        as Sasori is, he feels, and he loves, and he longs. His skin might not be soft to the touch, but
                        he
                        feels something so tender inside of him at times, and he just doesn't know what to do with this
                        shit. I
                        really wished you had talked about Sasori's humanity and what humanity might mean to him,
                        because he
                        wished for immortality and after having it for so long it really weighed on him when he met
                        Hinata and
                        this is so fucked up.</p>

                    <p>“Your deal is not to be used in battle. Saving me goes against that. You came alone, revealing
                        yourself.
                        Now your village knows who you have become.” Sasori prodded her where he knew it would hurt. His
                        deathbed wasn’t the best place to tell someone they shouldn’t have bothered.<br/>
                        “I don’t care about any of that. I need someone to have tea with in the middle of the night.”
                        Hinata
                        whispered. “You don’t understand what leaving you to die is.” Her voice cracked. “It’s selfish
                        of me,
                        but I can’t lose you like that. I can’t stand by and do nothing when I can prevent it. You guys
                        are all
                        the family I have.”</p>

                    <p>When Hinata told him he was her family and that no one wanted her and all he said was "you are
                        too
                        emotional", I really think he wasn't talking only about her. He is emotional about her too and
                        he
                        doesn't know how to deal. And Hinata doesn't understand him at all, and she still cares about
                        him so
                        much it hurts.</p>

                    <p>Did Sasori even feel when her hug? "Sasori closed his eyes until she was done having her moment."
                        Chucky
                        boy was thinking like "god give me strength".</p>

                    <p>“I’m not going anywhere.” Sasori's lip quirked up.<br/>
                        “That’s not funny.” Hinata pouted.</p>

                    <p>It kind of is funny, because I don't think he wanted to go away. If he did is becayse feelings
                        are
                        confusing, and feelings are a nuisance when you're trying to be an immortal in peace.</p>

                    <p>But Sasori was so done (angry as a consequence of concern, yeehaw) with Hinata reaching her limit
                        for him
                        he even brought Itachi up. This is peak cinema.</p>

                    <p>“She didn’t even try to stop herself, and you told the little girl her lungs would collapse?
                        Gentle fist
                        isn’t usually that violent.”</p>

                    <p>Meaning Sasori heard everything she said. FUCKING FUCKETY FUCK.</p>

                    <p>(dude, I don't think she ever told him he learned the murderer hands fucked up technique no jutsu
                        for
                        him... she should).</p>

                    <p>with love, not-itachi</p>

                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Lavender Umbrellas </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 1</h4>
                        </div>
                    </div>
                    <p>I didn't realized Kisame had his club jacket on at the beggining of the story and now I'm dying.
                        Not to
                        be horny on main, but already being horny on main: scarred knuckles. Thank you and good
                        night.</p>

                    <p>"His height, mass, tattoos, and sharp teeth made mothers hide their children and grown men avoid
                        crossing
                        his path. And, oh yeah, he was blue. Add the bandages and bruises, and he was the prime
                        candidate for
                        avoid at all costs." Seems like boyfriend material to me.</p>

                    <p>I always love the interactions between Itachi and Kisame, always. But their friendship in here is
                        specially funny because Itachi saw this fucking mamoth of a person and decided "should do the
                        job" and
                        attached himself to Kisame. Yeah, he keeps the lunatics at bay, but did he agree to that? Or
                        Itachi just
                        grew on him like mold?</p>

                    <p>I love when Kisame is entering the classroom and he is like "oh, they're all excited about a
                        small girl"
                        and she's small to him. Like, my love, everyone is small to you. I love all of his first
                        reactions to
                        Hinata, tbh, because he is so negative but at the same time he just doesn't care... Until he
                        does.</p>

                    <p>Deidara. Just Deidara. Alive, happy, well, in good health, with friends, warm in his jacket. Only
                        Deidara. An okay Deidara is a good Deidara.</p>

                    <p>"At least she could be grateful that she wasn’t in Neji’s class." Of course she is, the
                        motherfucker is
                        like... her jailer.</p>

                    <p>Okay, so... When Hinata looks at Kisame from under her bangs. She is just curious, but oh boooooy
                        if it
                        doesn't look like she's checking him out.</p>

                    <p>Neji cares about Hinata a lot, but I think this is the kind of caring that makes kids want/need
                        to
                        rebel... which is really weird, because Hizashi is such a nice and calm dad. How the fuck Neji
                        ended up
                        being a literal mother?</p>

                    <p>“Burnt rice, undercooked fish, and bruised fruit.” Sarcasm, refreshing.<br/>
                        It must be difficult to eat healthy with eating restrictions and no cooking skills. “Do you like
                        sashimi
                        and rice balls?”<br/>
                        “Yeah?” Hinata slid her bento toward him, plucking a rice ball out for herself. “You sharing?”
                        He
                        quirked a brow, pointing at it. Hinata nodded, nibbling on her rice ball. “Thanks.” He popped a
                        rice
                        ball in his mouth. They were too small for him. Hinata slide her chopsticks to him, ignoring the
                        amused
                        look on his face as he picked out one of the cuts of soaked fish. “This is great.”</p>

                    <p>I can't put in words how much I love their first lunch-sharing scene. Everything about the two of
                        them is
                        just so cute. It really sets their dinamic whole dinamic: Kisame isn't treating her like a
                        porcelain
                        doll, Hinata is treating Kisame with kindness, they are bonding without any expectations and are
                        being
                        treated differently in a positive way. And their little lunch interaction really is everything
                        Kisame
                        needed to go from indifferent to "oh, maybe she's okay" because his next thought is about her in
                        an
                        adorable way.</p>

                    <p>“She’s kind to a fault. I doubt she considered you any kind of threat.” A smirk spread across
                        Itachi’s
                        face. “And now that she’s warmed up to you, I suspect she’s going to be more prepared to make
                        friends
                        tomorrow.”</p>

                    <p>Itachi's only job in your stories is to be the love of my life-</p>
                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">What He Left Behind </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 6</h4>
                        </div>
                    </div>
                    <p>I promised, didn't I? So buckle up.</p>

                    <p>Let's start with the opening sentence, because I swear to god, when I read it I laughed so loud.
                        I knew
                        something dramatic was on the way. When Sasuke is absolutely livid about Naruto's behaviour?
                        Chief's
                        kiss. The "like some whore you took in for the sex"? Phenomenal.</p>

                    <p>Coming back at the beginning of the story after reading the ending makes me so fucking angry.
                        Like,
                        Naruto fucking saw what he had done to Hinata and he didn't even give her a change of deciding
                        what she
                        wants to do. And then Sasuke just deciding on the go that Hinata should go with him, like, my
                        man I'm
                        really happy this ship is sailling but his reasoning is nonexistent.</p>

                    <p>Sasuke thinking "this is the last time" about cleaning Naruto's messes. I could say this is a
                        mess he
                        will ending up loving to deal with, but you know me and you probably know exactly why I am
                        laughing so
                        much reading this sentence. I'm sure it will be the last time.</p>

                    <p>You said you didn't want bashing in the comments but my brother in christ this is fucking hard to
                        achieve, fuck me from behind, what in the everloving fuck is this, I want to do violent things
                        to Naruto
                        so very much.</p>

                    <p>Hinata had to put up with so much bullshit from him, from his bahavior to his tastes, to his lack
                        of
                        respect for her for the sake of love. Babygirl, this isn't love. I probably will come back to
                        this same
                        topic later, but the fact that he wanted her to act and dress in certain ways just to entertain
                        his
                        fantasy of a perfect home, and above all of that leaving her pregnant and alone is beyond fucked
                        up, if
                        not traumatizing. Naruto was everything she wanted and this is what happened, and there was
                        nothing she
                        could do to change it, because she didn't even have a chance to begin with. In short, I want to
                        commit
                        some violent acts.</p>

                    <p>"He wasn’t sure he wanted to see it when it split. But he would. He had made this decision." This
                        is not
                        the bare minimum at all, he isn't even having an affair with her, he isn't even responsible for
                        anything
                        but. but he is already being a better husband and father without even being a husband and father
                        (yet).
                        I think I like him so much it because in the principle of "I think, therefore I am", he thinks
                        about
                        helping Hinata and acts through it so throughoutly you can't even refute his intentions, you
                        know? That
                        is what makes him different from Naruto, he thinks and acts on it, while Naruto kind of denies
                        rationality until the very end. The "cogito, ergo sum" in Naruto's perspective is literaly "no
                        thoughts,
                        head empty" bc? How do you even? How do you even thinks shit the way he does and fucked people
                        up the
                        way he does with the hero moral complex without realizing he's being the biggest asshole in
                        town?</p>

                    <p>"The only thing they had in common abandoned them both." OUCH! And if they were lesser people,
                        like I am,
                        they would just get together out of spite. That would have been interesting, but I like that
                        Sasuke is
                        just livid instead. It's interesting tho that there is a void Naruto-shaped between them that
                        will be
                        filled with respect and love, this is nice.</p>

                    <p>ANYWAY "How did he still eat only take-out and quick-cooked rice?" She isn't judging him but she
                        is
                        judging him so hard LOL</p>

                    <p>I think one of my most recurrent thoughts while reading was "they need better friends" when it
                        wasn't
                        "why the fuck other people care so much about their lives?". In the first "why did you take her
                        in?" I
                        would be either answering "we have an affair" or literally asking the person to pay my bills if
                        they're
                        so entitled to care about my personal life, Sasuke in here is clearly a better person than I
                        am.</p>

                    <p>I love that one of the good things Sasuke thinks about Hinata is that she is sane, his bar
                        clearly isn't
                        very high, but who knows, right? I still want to murder Naruto for being an egoistical
                        dipshit.</p>

                    <p>It makes me sad that Hinata is grateful for being treated with respect by Sasuke, because they
                        don't even
                        know each other really well, he is just being a well-mannered human being and respecting her
                        space. This
                        is the bare minimum.</p>

                    <p>Yeah... the signs of abuse. This shit broke me. Not gonna lie and tell you I didn't laugh when
                        Sasuke
                        went for a hug, but boooy if this shit wasn't heavy.</p>

                    <p>"If I were late enough, sometimes he would say… that I wasn’t trying hard enough to make the
                        marriage
                        work. I didn’t love him enough…" First of all: psychological abuse is still abuse. Second of
                        all, the
                        nerve? He had his head so up his ass he couldn't see what he was doing to her? He wasn't trying
                        to make
                        this marriage work. As Dr. House said, marriages are built in lies, and Naruto took that at face
                        value.</p>

                    <p>“Once you start making excuses, it turns from bad behavior to abuse.” Yes.</p>

                    <p>If anything, they both can tell everyone later that what got them together was the shared hatred
                        for
                        ramen :D</p>

                    <p>I'm a Lord of the Rings gremlin, and I shit you not, I was so unbeliavably happy when they
                        decided on
                        watching it (I hope they watched the extended version). I really am a cheap date, it's so easy
                        to make
                        me happy. I love them bonding through watching movies.</p>

                    <p>The "do you need me there?" "that would be nice" "i will be there"... it's about that.</p>

                    <p>Sasuke is also officially promoted to friend, which is nice (right next ot being promoted to
                        dad).</p>

                    <p>“There, you can name it after flowers.” Or after your mother, Sasuke, we might never know
                        ¯\_(ツ)_/¯</p>

                    <p>"The look at her was soft. The look at him was daggers." IF THIS ISN'T MY BOY, NEJI! &lt;3 It
                        makes me
                        lose my shit everytime he comes up, he is such a pushy mother, this is gold.</p>

                    <p>Hinata's tantrum in the car is the best piece of literature ever, I laughed so hard because
                        girlie has
                        been through some deep shit, she deserves to go apeshit sometimes, okay? She even cursed!</p>

                    <p>“We could always just dye her hair.” He got a smile.<br/>
                        “I’m not dying her hair.” Hinata squeaked, her smile growing.<br/>
                        “Why not? If it’s blond, it will be easy.” Sasuke shrugged. “Dye it rainbow. The kid will love
                        it.”</p>

                    <p>I wish my dad loved me like that LOL</p>

                    <p>"It’s just like a roommate, and the roommate gets a dog." I compared my friend's kid to a dog
                        once and
                        she said it was actually worse than having a dog, the father wasn't very happy with us but he
                        didn't
                        disagree lol. Point is, at least he wants the kid.</p>

                    <p>"If you want to move out on your own or get a boyfriend or something." Honey, you've got a big
                        storm
                        coming.</p>

                    <p>I think this story awakened a monster in me, the monster that loves the trope of roommates acting
                        like
                        they're married until they fall in love.</p>

                    <p>"She was cute. There never was a question. She was pretty." AAAAAAAAAAAAAAAAAAAAAAAAAAA-</p>

                    <p>The part where Hinata has craving is so good, everything about this moment is so nice and cute
                        and
                        genuine and- I love them, your honor.</p>

                    <p>I totally forgot about the bath situation. I feel sorry for Hinata, but the image of her
                        squeezing
                        Sasuke's hand through the stitches like she's breaking his bones never fails to amuse me.
                        "Sasuke would
                        have to help her bathe, which was going to be a wonderful time, he was sure." I am sure as well
                        ( ͡° ͜ʖ
                        ͡°)</p>

                    <p>“Why aren’t you at work?”<br/>
                        “I don’t want to come back and find a pregnant woman bleeding out on the floor.”</p>

                    <p>This is my kind of humor. I fucking love him.</p>

                    <p>Sasuke 🤝Me<br/>
                        planning Naruto's demise</p>

                    <p>"She conformed to every little thing he complained about, and he left her anyway. Didn’t that
                        make it
                        worse? She tried so hard and came up empty in the end." It was an abusive relationship, it
                        doesn't
                        matter the reasoning Naruto put up later, because it was fucking abuse still. Nothing she could
                        do would
                        change what he wanted to do, what he had done.</p>

                    <p>Oh yeah, the cringe baby clothes. Why does this shit even exist? Why do people even buy that kind
                        of
                        thing?</p>

                    <p>"To be fair, I think they should have scared more of the girls in school with horror factors like
                        that."
                        The sick amusement I could have had in a class like that is real. I feel robbed.</p>

                    <p>Everything about them bumping on Sakura was uncomfortable and I am happy she gets her shit
                        together later
                        :D One less problem to be dealt with.</p>

                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">What He Left Behind </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 9</h4>
                        </div>
                    </div>
                    <p>Okay, I am not normal about Sasuke here. As in, absolutely not normal. I tried to start this
                        comment
                        three times already because every time I tried my brain went [oijsdofishuifhsijaofja!!!!!]
                        because he is
                        so fucking nice. I just gave up, I will just go crazy and deal with it later.</p>

                    <p>This comment starts at chapter 7 and I can't. It's just. Just. He is so attentive, you know? He
                        notices
                        shit, and he talks about it without being judgy. And he calls the apartment [their home], he
                        makes
                        Hinata feel comfortable to be herself without fear, he calls her a fucking savage bunny I'm
                        going to hit
                        someone over with a car- I will fucking cry.</p>

                    <p>Also, Sasuke struggling to be savage with the wings? Poetic cinema.</p>

                    <p>It fucks me over from behind the fact that Hinata allowed herself to joke around with Sasuke,
                        like when
                        she told him off... Because it was mutual, because she knew he didn't mean anything by what he
                        said
                        udausfhaifuh chapter 7 is everything to me.</p>

                    <p>Ugh, Naruto.<br/>
                        Ugh, selfishness.<br/>
                        Ugh, making a person work their ass off for a relationship to work instead of having both sides
                        working
                        together.</p>

                    <p>I FORGOT HINATA MADE SASUKE BLUSH AND I AM DYING BC IT CAUGHT ME OFF GUARD!! and I think if he
                        wasn't
                        already falling in love with her, he started to fall here, but who knows?</p>

                    <p>“It doesn’t have to be, but you know some guys think single moms are hot.” Sasuke woke up one day
                        and
                        said "milf rights", I guess.</p>

                    <p>Not French philosophy, but when Hinata described Sasuke as someone simple, someone who is more
                        likely to
                        do give something you need than something pretty for the sake of it, and this is pretty much how
                        he
                        treated her so far. Their bonding moments were all in the comfort of their own home, he gave her
                        the
                        things she needed from safety to respect to the fucking crib. He treated her this way without
                        expectations besides being treated simply, as well. And when Sasuke described what kind of
                        person would
                        like to date her, this sneaky little shit also described himself (not only bc he things single
                        moms are
                        hot), but he appreciate everything she does, even when he doesn't say it. Sasuke makes Hinata
                        feel
                        comfortable at all times. Hinata eats like a horror show rabbit in front of him, Sasuke doesn't
                        give a
                        fuck about dinner, and compliments her hair, like hello???? When Sasuke got Hinata the chair? It
                        proved
                        my previous point even more.</p>

                    <p>“You need someone who thinks of you when they think of their perfect wife, not someone else you
                        have to
                        be like.”</p>

                    <p>EX FUCKING CUSE ME, SIR?</p>

                    <p>Hinata's saga in the pregnancy classes or whatever that was was so fucking entertaining, girlie
                        was so
                        angry and Sasuke was so amused. At least he was able to make her laugh, it was cute. I think if
                        Sasuke
                        in here would be the most insufferable man in the planet if he had a kid with Hinata, I mean, he
                        is
                        halfway there with the child that isn't his, but imagine the sheer chaos. He is already
                        suggesting to
                        antagonise the pregnant catty gossips, I can't even imagine what more he would come up with.</p>

                    <p>"He came into the smell of… ramen, which was concerning." BOOOOY YOOOO and back to zero we go,
                        because
                        Hinata lost about 90% of the emotional recovery she had done in the previous chapters. Yikes,
                        just
                        yikes.</p>

                    <p>I could sit here and write a literal paper about Naruto in this story and it wouldn't be enough
                        to
                        explain how much I want to hit him with a chair, so I will just say that I'm happy with how
                        Sasuke put a
                        foot down on his bullshit. Also, someone please hug Hinata :&lt;</p>

                    <p>“I would have to face him in court,” as if he would show up lol</p>

                </section>
                <section className="block u-p-3 light_theme-nari">
                    <h2 className="font-weight-bold ">Bread and Tea</h2>
                    <p>"She bowed her head and exited the store, and without much more thought, she crouched down there
                        on the
                        curb to eat the whole bread." Well, you know a mf is having a fucking bad day when the sit on
                        they curb
                        to gorge down a whole loaf of bread. Not only that, but Hinata thinking she wanted to go back
                        there and
                        get another but didn't want to come out as weird... babygirl you just ripped apart a load of
                        bread while
                        sitting on the curb... breadboy is right there, I don't think he will mind you coming around for
                        more
                        bread.</p>

                    <p>"Hinata always pictured something more like a shrine or antique weapon shop." Now, that would be
                        funny.
                        What kind of shrine Sasuke would even manage? Antique weapons I can see, but the shrine was a
                        funny one.
                        Not as funny as Sasuke watching Hinata rip the bread apart from the bakery and wondering if she
                        would
                        come back, but still funny.</p>

                    <p>"She looked empty now." WELL, MAYBE YOU SHOULD GET HER FULL of bread, of course.</p>

                    <p>Okay, it was very cute that he added another flavour and thought about adding chairs... Can't
                        have his
                        favorite costumer eating out in the fucking rain. He was like "damn dude I don't want people to
                        perceive
                        me but she's doing that anyway so I might as well be nice" and it was very cute.</p>

                    <p>They are a two months and my guys is only now talking with her, you need to step up yo game,
                        breadboy.</p>

                    <p>AND HE WANTS TO MAKE SOMETHING WITH CINNAMON IN THE FUTURE!! Nevermind what I said before his
                        game is up
                        already.</p>

                    <p>Well, as a depressed cave gremlin as well, I can say that there is something really therapeutic
                        about
                        forcing yourself to enjoy the little/meaningless things in life. It won't make your problems go
                        away,
                        but you will have something to brighten up your day even if you feel like absolute shit. Hinata
                        enjoying
                        her bread reminded me I enjoyed my bread this morning and now I'm extra happy.</p>

                    <p>OH MY GOD HE SAVED HER SOME BREAD WHEN SHE DIDN'T COME!! I knew she was his favorite
                        costumer!!</p>

                    <p>Sasuke shrugged. “You have come every other day for three months now.”<br/>
                        Hinata paused to chew. “I like bread.” There is something so funny to me about this dialogue.
                        Sasuke
                        went from being chased by girls all around to being Hinata's "I like bread" dude.<br/>
                        “Then what do you do?”<br/>
                        “I eat bread.” This is amazing. I love them, the depressed bread eaters.</p>

                    <p>Sasuke aced bread making by rage and stubborness only- I love this guy. This is how you live your
                        life. I
                        bet if I had more drive I would find some philosophy in this story, because boy oh boy it is a
                        beautiful
                        story and it feels very comfy to read it when my life is going to shit, but I don't have a lot
                        of drive
                        at the moment so I'll just tell you that all of this [gesturing vaguely with my hands] is making
                        me
                        happy.</p>

                    <p>“Now the goal is to open every day and sell bread, and when that doesn’t work anymore, I’ll do
                        something
                        else.” Not gonna lie, I teared up lol</p>

                    <p>She's going to keep bringing him tea (ಥ﹏ಥ)</p>

                    <p>"Sometimes they didn’t say a word to each other." And sometimes this is literally everything
                        someone
                        needs.</p>

                    <p>In my game of "how is Lavender going to torture Hinata in her new story?" I didn't image you
                        would use
                        literal torture this time :D What the fuck, girl LMAO</p>

                    <p>OH MY GOD I WANT HIM TO TEACH HER HOW TO MAKE BREAD LIKE IN THAT GHOST SCENE WHEN THEY'RE DOING
                        THE
                        POTTERY STUFF- oh shit, he is actually going to teach her how to make bread lol</p>

                    <p>He is watching her while she watches the bread, this is a love triangle I've never imagined.</p>

                    <p>I was about to talk about your torturing methods bc... I liked it, I really like torture, you
                        know me...
                        but I started laughing so hard because this is a fluffy fluff about healing and bread and moving
                        on, and
                        then boom torture. Anyway, you invented the reverse gentle fist in Clouds and now we have baker
                        mode
                        gentle fist, I love you.</p>

                    <p>HE CLEANED HER NOSE FOR HER, THE YEARNING!!</p>

                    <p>The end of the story felt like when in Mulan the old lady yells "would you like to stay forever?"
                        when
                        Mulan invites Shang for dinner. Sasuke is this close to invite her to stay forever, I know it,
                        she is
                        his favorite costumer after all.</p>

                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Lavender Letter </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 1</h4>
                        </div>
                    </div>
                    <p>It seems like we joked a little too close to the sun, my friend.</p>

                    <p>I know I already told you but I'm going to say it again: RATED M FOR MURDER!!!!!!!</p>

                    <p>I love and I live for every single Neji you write because all of them are such grandmothers I
                        CAN'T!!!
                        And not to mention the "he is…" "a murderer, i know" BECAUSE HE'S COMPLAINING AND HE DOESN'T
                        EVEN KNOW
                        WHAT'S COMING LMAO</p>

                    <p>Yes, Neji, Hidan kills people… and he looks damn good while at it.</p>

                    <p>"She had long since learned to read chicken scratch, or maybe he just got better with time." Yes,
                        give me
                        Hinata getting snarkier and snarkier after every interaction with Hidan, I so want to see
                        it.</p>

                    <p>"Putting ger address down should have been a red flag." Girl, you have a big storm coming.</p>

                    <p>I love Hidan's character because being either canon or fanon, I never know if he is insane or
                        very, very
                        sane. It fits him being insane if you're thinking about it like a normal person, but it also
                        fits his
                        personality to be very aware of everything and decide to go apeshit just because. Is he actually
                        insane
                        for thinking what he is doing is okay? This is a nice topic to think about and analyse, I think.
                        Anyway,
                        I stand with Hinata's canceled husband.</p>

                    <p>I wonder if Hidan knows about the guy he killed as well, or if they will ever talk about it, or
                        if
                        they're going to kiss because of it- Anyway.</p>

                    <p>"It made her laugh when he started writing out the swear and then scribbling it out for her
                        ‘delicate
                        eyes.’ So at least, he considered being considerate." HE GOT HER BY BEING FUNNY!!! and also hot,
                        but I
                        don't think she's going to comment on it, she's very polite.</p>

                    <p>"Hidan was a bastard, but he knew he was a bastard. At least he wasn’t lying to himself." One
                        point for
                        sanity, I guess.</p>

                    <p>I think it's cute how Hidan waits for Hinata's letters like a dog waiting for the owner.</p>

                    <p>"He didn’t really care how she looked. It would make the mental picture more complete." Peak
                        long-distance relationship dynamic, if you ask me.</p>

                    <p>Okay, I have things to say about "It took a weird pressure off of him to keep the act up." and
                        about
                        "Hinata never asked him why or how he did any of his murders and squashed his theory that she
                        was
                        writing a book. She could have made one by now if she just collected and printed the letter he
                        sent over
                        the years. It would probably be that long."</p>

                    <p>1. She already knows the worst of him, everyone knows the worst of him, but at least she isn't
                        actively
                        trying to fix him. And this is something I always say means love, that when someone knows you at
                        your
                        worst and about how horrible you can be and still chooses you, it means something. Not having to
                        impress
                        or scare someone off really lifts something off of you, I think. It's nice to be seen and
                        tolerated, if
                        not accepted.<br/>
                        2. They talked a lot. A lot, a lot. They talked so much Hinata could print a fucking book if she
                        wanted.
                        And Hidan just let it happen ¯_(ツ)_/¯ It seems the prude girl is getting to you, Hidan.</p>

                    <p>"Hidan always wondered if the last one he read would be the last one he would receive, and he
                        would have
                        to find something else to make his prison life interesting." IT SEEMS LIKE YOU ACTUALLY ENJOY
                        THE
                        LETTERS, HIDAAAAAAA- I'm sorry, I'm insane.</p>

                    <p>"Speaking of damned, the edges of his collage were Jashin symbols." seems about right.</p>

                    <p>Hinata has the patience of a saint with Hidan because she's used to brats, got it.</p>

                    <p>The general ban Hidan got is peak comedy because fuck it anyway. Stabbing people with spoons, why
                        the
                        fuck not.</p>

                    <p>I like the idea that Hidan is an oversharer, points if he is an oversharer with Hinata because he
                        doesn't
                        know how to act around someone that isn't judging him (very much). "To be fair, prison didn’t
                        have a lot
                        of completely innocent people, so maybe she was assuming the worst of everyone."</p>

                    <p>AND KAKUZU IS HEEEEEEEEEEEEERE!!!!!!!!!!</p>

                    <p>"Kakuzu liked one thing in life, money. It’s what got him in prison in the first place. An
                        embezzlement
                        case. He wasn't embezzling. He killed the man embezzling from him." Can't say he was wrong so I
                        won't
                        say it :D</p>

                    <p>Hidan and Kakuzu are a match made in hell and it amuses me to no end &lt;3 The hitman and the
                        ritualistic
                        murderer are roommates!</p>

                    <p>"Prison was probably where Hidan belonged, and might as well enjoy it." Boy, just you wait.</p>

                    <p>So………….. how about putting "romantic comedy" as a tag?</p>

                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Lavender Letters </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 2</h4>
                        </div>
                    </div>
                    <p>I love how we start this chapter with Hidan amused by Hinata's rage. I think this should be a
                        staple for
                        them as a couple, just saying. I am also laughing a lot about how she just tells him everything,
                        like??
                        My girlie??? She told the psychotic murderer about her fucking crush, I swear to god.</p>

                    <p>Hidan doesn't read fan mail but he waits impatiently for Hinata's letters, yeah, he clearly
                        doesn't have
                        a favorite.</p>

                    <p>"I think that's a federal crime." And I bet my fucking arm Kakuzu was thinking "we're already in
                        jail",
                        so, sure.</p>

                    <p>OH MY GOD THE GROUPIE PICTURE LMAO AND I AM NOT EVEN SURPRISED MY THE DEADPAN "sacrilege" I'M
                        GOING TO
                        FUCKING DIIIIIIIE</p>

                    <p>Reading Hinata's whole pov felt like that meme "maybe the one piece was the friends we made along
                        the
                        way" but in truth, it was more along the lines of "maybe the missing piece in your life was the
                        murderer
                        in jail you found along the way", if you catch my drift.</p>

                    <p>"He was blunt, brash, and a bastard. And Hinata had to admit he might be her best friend." I'm
                        literally
                        so sorry for her but her misery is my entertainment. Also, she needs better friends. If the only
                        person
                        you trust with your feelings is a total nutcase, then maybe there's something wrong with the
                        people
                        around you, just saying.</p>

                    <p>"What a sad thought. Her best friend was a convinced serial killer. If she ever said that out
                        loud… well,
                        maybe she should never say it out loud." MAYBE SHE SHOULD??? It would be amusing as hell, I'm
                        sure of
                        it.</p>

                    <p>I'm literally chanting inside my head "please make her worse please make her worse please make
                        her wor-"
                        because I think everyone has the potential to go to prison for capital crimes at least once :D
                        But the
                        idea of the cutie teacher killing the negligent parents is too good to go to waste.</p>

                    <p>"Hinata reached forward and pulled a childish sticker out of her supplies to add to the
                        letter."<br/>
                        "At the end, he chucked at the note of ‘you’re a bad influence’ with a ‘You Did It!’ sticker
                        next to
                        it."<br/>
                        That's it, they are my special little babies.</p>

                    <p>They are weirdly cute, tbh. I don't know what I expected, but it seems on-brand to you. Even if
                        Hidan is
                        a psycho, he is so cute in his own fucked up, twisted way.</p>

                    <p>“She’s got a bleeding heart, but she’s not going to support me.” She will, just not in the way
                        Kakuzu
                        expects lol</p>

                    <p>"He was the type that would have fully milked the idea of having murder groupies if someone freak
                        found
                        murdering your own employee sexy." I laughed so hard I hurt my fucking throat, god bless.</p>

                    <p>"These women saw him acting up in court and wanted him to father their children, and people
                        called him
                        psycho?" This is such a good point, because I see people wanting to fuck Ted Bundy and Richard
                        Ramirez
                        and other fucking maniacs and I am like ?????????are you people fucking mad????</p>

                    <p>“I bet she would send money if you asked.”<br/>
                        “Greed is a sin.”</p>

                    <p>Kakuzu is my favorite boi.</p>

                    <p>My girl Hanabi out there not giving a fuck about coming back home, and honestly, can you blame
                        her?
                        Nope.</p>

                    <p>I am team "ignoring grandma's Neji worries" because it seems to get his knickers in a twist. It
                        seems
                        like Hinata agrees with me.</p>

                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Red Memories </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 1</h4>
                        </div>
                    </div>
                    <p>Only you have the power to make me get up from the comfy to write you a comment, but alas, I'm
                        not
                        actually complaining because HERE IT IS, THE BABY I HELPED BRING TO THE WORLD!!!!!!!! (I'm
                        holding
                        depressed, anxious, amnesiac Sasuke like the opening scene in Lion King).</p>

                    <p>While I was reading the first paragraphs about how Sasuke felt I was thinking like "imagine if
                        this bitch
                        just got a rock thrown at him lmao", but anyway. His last and yet confused memory about Hinata
                        was a
                        mission, did it trully happen or nah? Because I want to know about them going in missions
                        together and
                        getting to know each other. You don't really know someone until you see them at their worst,
                        i.e. both
                        of them stranded in the Rain Village and just hating every second of it together. I want them be
                        miserableeeeeeeeeeeeeeeeeee- No, I don't. I want the soft and cute stuff we talked about. The
                        cute
                        dates. The cute quality time at home. Everything we talked about. I also want a little bit of
                        drama.</p>

                    <p>"Hinata’s hand ghosted over his face to brush hair off his forehead." (!!!!!!!!!!!!!!!!!!!!) LET
                        HER CARD
                        HER FINGERS THROUGH YOUR HAIR, YOU ABSOLUTE MONSTER!!! I'm kidding, I'm SO kidding. But I need
                        to point
                        out that I love it when a character is scared of people being soft and nice with them because
                        they're
                        not used to it or because they are so used to being treated like shit/used to scaring other
                        people away
                        but then they absolutely MELT when they get some... ugh... English doesn't have the word carinho
                        so
                        kindness will have to do.</p>

                    <p>“Well, you’re not panicking about your arm, so you’re not that fried.” Sakura put a hand on her
                        hip.<br/>
                        Sasuke waved his stump. “This is old news. Fix my head.”<br/>
                        “It’s not that easy.” LMAO GET HIS SKINNY ASS, SAKURA</p>

                    <p>Imagine how much it would suck to start your day with your amnesiac husband not remembering you
                        and
                        calling you "the Hyuga girl" when you are very much an Uchiha girl. Damn. At least his wife is
                        pretty as
                        fuck, this is a pro.</p>

                    <p>Also... his first flashback is about missing her. I can't. But the Rinnegan feeding him his lost
                        memories
                        is a funny detail.</p>

                    <p>Sasuke thought Hinata was going to use the murder mittens on him when in reality she just went
                        for a hug,
                        I don't know if the hug is better or worse for him in this case. Touch-starved depressed man
                        deserves
                        some hugs. He is so baby, I feel so bad for him lol I wish him all of the comfy fluffy and warm
                        best.</p>

                    <p>I loved that Sasuke's coping mechanism is to spend some time between Hinata's boobs. Jokes aside,
                        I'm
                        just happy he feels safe with her. And I can't wait to see her cooking stuff for him because
                        it's for
                        him instead of treating him like a second option, I want to see Sasuke being pampered and crying
                        and
                        being emotional.</p>

                    <p>I love this story. I love how we came up with it. I love all of your touches. I love that it's
                        sad but is
                        the flavor of sad that amuses me. You are my favorite writer, my favorite girlie, I love you and
                        your
                        brain &lt;3</p>

                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Red Memories </h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 2</h4>
                        </div>
                    </div>
                    <p>I really can't with this story. I was there to raise its bare bones from the earth like a
                        deranged
                        necromancer and I know what is happening and some of what is going to happen, but I love how you
                        can
                        surprise me even so (!!!!!!)... That being said:</p>

                    <p>Oh my fucking fuck, Sasuke's doubts are showing right at the beginning and I can't stop smiling
                        because
                        Red's Sasuke is my baby, and I want to see this boy going through hell and coming back for some
                        hugs.</p>

                    <p>"Did she get sealed to marry him? Why would he have let her do that? How did this even start? And
                        why did
                        she return the following day with food if her husband didn’t even know her?" SASUKEEEEEEEEEE-
                        Because
                        she loves you, even if you don't remember the why and the how, she fucking does. I love it when
                        he
                        thinks "if she's smart she's going to leave him behind" because dude, this isn't her first
                        rodeo, even
                        tho the cowboy and the bull are the same.</p>

                    <p>Sasuke's inner questions about what made him love Hinata in the first place are really amusing to
                        be
                        because... duh, he is going to find even more things to fall in love with her again. I think
                        that, in
                        the end, he could really think that there wasn't possible to not fall in love with her again,
                        even if he
                        fell in love for different reasons this time. I'm just theorizing here, don't mind me.</p>

                    <p>“I’m not used to the idea of having someone to miss me when I am gone.” Ouch. Also...
                        Beautiful.</p>

                    <p>Do you know what would be pretty fucking funny? Sasuke falls in love for entirely different
                        reasons than
                        before and then gets bothered with himself because there's so much about Hinata to love and he
                        feels
                        like he wasn't being appreciative enough. I am here for the crisis.</p>

                </section>
                <section className="block u-p-3 light_theme-nari">
                    <h2 className="font-weight-bold ">Office Mishap</h2>
                    <p>OH MY GOD IT'S HAPPENING LMAO<br/>
                        I'm actually seeing it posted with my own eyes and even though I read it beforehand I still
                        can't
                        believe you've written it. I can't stop fucking laughing, I love it so much.</p>

                </section>
                <section className="block u-p-3 light_theme-nari">
                    <h2 className="font-weight-bold ">Ladybug</h2>
                    <p>HELL YEAAAAAAHAHHHHHH!!!!!!!!!!!!</p>
                </section>
                <section className="block u-p-3 light_theme-nari">
                    <h2 className="font-weight-bold ">His Type</h2>
                    <p>I might tell you that several times in several different ways, but you are my favorite author -
                        not
                        because you're my best friend, not because you write ideas I give you or help you with, not even
                        because
                        you write the things I want to read (you know I'm chaotic, and that I have weird standards, but
                        your
                        writing fits into everything that I love and will always want to read). You're my favorite
                        author
                        because I think there's very few people who can play with a character like you do. They're your
                        Barbie
                        dolls, but they're not so ooc it feels weird. I told you once that my favorite part of your
                        characterization of characters is the perfect balance between their original personalities and
                        the
                        environments you come up with in the stories. They're them, but they're also little fractional
                        people
                        responding accordingly to situations, whether they're nice or antagonistic. I think this is one
                        of the
                        strongest characteristics of your writing.</p>

                    <p>You messed with Kankuro quite a few times, and you know I've been in love with your version of
                        him since
                        Sands, and this is the first time since Sands I'm seeing him in the spotlight (I promise I'll
                        read
                        Better Late XD), and babe... I love him so much. He is such a prickly little bastard. And he
                        feels so
                        fresh and so real and so in contrast. The comment about fuck what his dad would think about
                        Temari's
                        wedding was so fucking on brand to his general personality and when I read it I felt that
                        sparkle of
                        love and administration I fell for you every time I'm reading something of yours, because I'm
                        reminded
                        you love what you do.</p>

                    <p>I'm particularly enamoured with the fact that it's Kankuro'a point of view. I think he is
                        hilarious, same
                        way I think you are. The dry little comments, the *at times* degrading ways he thinks about
                        himself, the
                        dry comments about everything, the "Of course, if she was a friend of Naruto’s, she was a friend
                        of
                        Gaara’s."</p>

                    <p>Btw, he is such a fucking bottom. Of course he would like dominant women lmao. Speaking of which,
                        I love
                        when a character is all "eh, not my type", because it strays from that line of "everything will
                        fall
                        together because they're meant to be", which is not something bad, but it does happens a lot.
                        The Not My
                        Type™ is always a pleasant surprise, because there's an active attempt from the characters to be
                        around
                        each other. </p>

                    <p>One of my favorite quotes of all time is from the trilogy Captive Prince, in which someone says
                        "I missed
                        our conversations", because it's simple and it struck my heart, and I think talking easily with
                        someone
                        is one of the loveliest forms of love out there. Kankuro liked talking to Hinata, and he
                        remembered her
                        because of that, not because of her face or status or anything else. He just liked to talk with
                        her, it
                        was painfully sweet and genuine. "Maybe it was precisely because he didn’t talk to her like he
                        was
                        interested in her, and wasn't trying to impress her, but she seemed impressed anyway." Because
                        there is
                        always some kind of pretence in trying to impress someone, so when someone is honestly
                        interested in the
                        soft, hidden parts we don't show off, it leaves quite the impression. </p>

                    <p>The way Kankuro felt when he saw Hinata with Mirai and thought she was married... I'm really a
                        softcore
                        masochist. I'm so enamoured with him and the way he reacts to her. I fucking love Shikamaru for
                        subtly
                        dropping the "she's single" card. Shikamaru, homie, you'll always be famous. </p>

                    <p>Wife material. I'm literally barking and howling. His fucking reluctance in accepting he is
                        interested,
                        I'm dying on the floor. </p>

                    <p>Shikamaru clocked that bitchboy so fast, as he should. I'm sure he's going to enjoy torturing
                        Kankuro for
                        saying he almost forgot about her when they *eventually* get together. </p>

                    <p>It was such a lovely and warm story. I love it with all of my heart. </p>
                </section>
                <section className="block u-p-3 light_theme-nari">
                    <h2 className="font-weight-bold ">Heart On The Mat</h2>
                    <p>Itachi really went through all of the emotional spectrum of "I'm going to take him down a peg" to
                        "oh no
                        he likes to get pegged" and I think that's beautiful. </p>
                </section>
                <section className="block u-p-3 light_theme-nari">
                    <div className="row u-py-h">
                        <div className="col">
                            <h2 className="font-weight-bold ">Lavender Lights</h2>
                        </div>
                        <div className="col text-right">
                            <h4>Chapter 1</h4>
                        </div>
                    </div>
                    <p>Literally writing this comment by hand in an actual notebook because I have so many feelings and
                        I think
                        typing it all out would tamp down the hype.</p>

                    <p>Okay, a-okay. I'm fine. Everything is fine. But let me say: I can't even put into words how I
                        feel right
                        now. This story is one of our babies, one of our lovely and coveted babies! And the baby is
                        out!! And I
                        know how hard you worked to sort it out for me, and then how hard you worked to post it on time
                        in the
                        last Monday of the year. AND AND AND!!! THE COVER I MADE IS HERE, MY FAVORITE COVER IS OUT OF
                        THE
                        BASEMENT!!! I cried, okay? I'm still crying a little bit. I'm so happy and grateful the feeling
                        is
                        leaking out of me.</p>

                    <p>I pinky promised not to spoil the info from our conversation, so here goes my totally spoiler
                        free
                        comment for this week's chapter: [screaming, crying, throw in up]. Hope this helps.</p>

                    <p>I love how Hanabi is defiant in every step of the way to the office, and how it feels like she's
                        there
                        for Hinata if Hinata ever feels like breaking someone's face with a brick. And I think Hinata
                        should
                        break someone's face with a brick, since her work conditions suck and her boss is an asshole. It
                        wouldn't surprise me if she developed panic attacks simply by having to talk to Hiashi if she's
                        already
                        nervous by noticing he's upset about something. Also, not her fucking job to be Hanabi's mom.
                        Fuck
                        Hiashi, me and my homies hate Hiashi. </p>

                    <p>I think one of my favorite things about the conversation Hinata and Hanabi had after Hiashi
                        demised the
                        moving-on-song is that it gives emphasis to the "He curated her image and controlled what she
                        did. Maybe
                        that was the problem." because old capitalist pigs don't know shit about the people they're
                        trying to
                        sell to, and because Hanabi sings Hinata's songs, Hinata who lived through some things and know
                        what the
                        fuck she's talking about, it's easier to stay in the charts despite the difference in image.
                        Also, image
                        and fashion sense do sell an artist's relevance, so either Hinata's empowered style is far too
                        industrialized by her father or Hanabi's style is far too natural so she won't feel like a nepo
                        baby for
                        the fans XD I love a good sociological analysis in my fanfic comments, as you probably noticed.
                        I feel
                        so sorry for Hinata, the imposter syndrome is probably her best friend at this point. </p>

                    <p>I love how Hiashi is like "you're not good enough" when he's the one forcing her to be someone
                        she isn't
                        AND controlling her image. Talk about hypocrisy. Fucking love how Hinata still has that sparkle
                        of
                        defiance in her to recognize if Hanabi is on top, she's there too because the songs are hers
                        too, so
                        Hiashi can eat shit and die. </p>

                    <p>Deidara, you will always be famous. My gayboy, freak child. Isn't it funny how punk he is and he
                        is still
                        friends with a corporate asshole? "Their protest was held off by another employee telling them
                        it was
                        fine." It is the funniest thing in the world because every other employee of Sasori is already
                        used to
                        this shit, so they just let Deidara out and about because whatever the fuck are they gonna do
                        about? </p>

                    <p>Reading the whole first half of Sasori's part makes me grin and think "hopefully nothing bad will
                        happen
                        to your carefully crafted company image, huh lmao", so, yeah. There's that. Hanabi would be far
                        too
                        wild, and wouldn't it be hilarious. </p>

                    <p>Sasori: I have this headache that comes and goes. <br/>
                        [Deidara arrives in the office] Sasori: here it is again.</p>

                    <p>I know I promised I wouldn't spoil anything, but the "you used to be fun" always gets me because
                        I think
                        about when they were younger and if they went to mosh pits together and if they helped each
                        other with
                        their makeups and clothes and if they talked about art and revolution together and. And I have
                        charms of
                        them dangling on my pencil case. Yeah. </p>

                    <p>I think, in the end, pretty much everything that's going to follow can be pinpointed back to
                        Sasori
                        trying not to have a marketing nightmare to deal with, and isn't it beautiful. </p>

                    <p>ALSO ALSO! I love how Deidara is "I don't like this, but this is not for me anyways so I won't
                        waste my
                        energy". I wish every single fandom space was like that. I'm also giggling and blushing and
                        kicking my
                        feet because you used my opinion when you wrote his vision on corporate shit XD </p>

                    <p>Can't wait for Deidara to meet Hanabi and be like "yo ho, what the fuck" because this is
                        certainly how I
                        think this is going to go. Waiting anxiously for when he finds out where the songs he loves so
                        much came
                        from. </p>
                </section>
            </div>
        </div>

    )
}